/* CreateEditExclusionComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
// const _ = require("lodash");
const Renderer = require("./CreateEditExclusionRenderer");
/**
 * @class CreateEditExclusionComponent
 * @extends EventEmitter
 *
 * @fires CreateEditExclusionComponent#Data
 * @fires CreateEditExclusionComponent#Error
 * @fires CreateEditExclusionComponent#Shutdown
 */
class CreateEditExclusionComponent extends EventEmitter {
    constructor(data) {
        super();
        this._data = data;
        this._item = data.item;
        this._exclusionEntity = this._data.exclusionEntity;
        this._activeOrgId = this._data.orgId;
        this._modelUserFeedback = this._data.muf;
        this._exclusionTypes = data.exclusionTypes;
        this._typeBaseMap = data.typeBaseMap;
        this._parent = data.parent;
        this._registerListeners();
        this._renderer = new Renderer(this);
    }
    get renderer() {
        return this.getRenderer();
    }
    get rootElement() {
        return this._renderer.getRootElement();
    }
    get activeOrgId() {
        return this._activeOrgId;
    }
    get userFeedback() {
        return this._userFeedback;
    }
    // prettier-ignore
    set "$teve.ui.context"(context) { //jshint ignore:line
        this._context = context;
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    _shutdown() {
        this.emit("Shutdown");
        this._unregisterListeners();
        return Promise.all([this._renderer.shutdown()])
            .then(() => {
                this._renderer = undefined;
                this._shutdownProm = undefined;
                this._data = undefined;
                this.removeAllListeners();
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }
    _whenModelIsReady() {
        this._typesDropDownOptions = Object.keys(this._exclusionTypes).map((ex) => {
            return {
                label: this._exclusionTypes[ex],
                value: ex,
            };
        });
        this._deviceTypeOptions = Object.keys(this._typeBaseMap).map((type) => {
            return {
                label: this._typeBaseMap[type],
                value: type,
            };
        });
        return Promise.resolve();
    }
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }
    closePopUp() {
        this.rejectPopUp({userRejected: true});
    }
    async saveandclosePopUp(item) {
        this.resolvePopup({[item.exType]: item.value, description: item.description});
    }
    resolvePopup(data) {
        this._context.resolve(data);
    }
    rejectPopUp(data) {
        this._context.reject(data);
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = CreateEditExclusionComponent;
